<script>
export default {
  render() {
    return <div>{this.$slots.default}</div>
  }
}
</script>
